import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import SoundType from "../../sound/util/SoundType";
import AbstractPopupMediator from "../../ui/AbstractPopupMediator";
import ClickEaterFactory from "../../ui/ClickEaterFactory";
import SystemMessage from "../model/SystemMessage";
import SystemMessageEvent from "../model/SystemMessageEvent";
import SystemMessageOption from "../model/SystemMessageOption";

export default class SystemMessagePopupMediator extends AbstractPopupMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {SoundManager} soundManager 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, soundManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._soundManager = soundManager;

        /** @type {SystemMessage} */
        this._systemMessage = this.getCustomData().systemMessage;
    }

    initialize() {
        super.initialize();

        this._target.panel.initialY = this._target.panel.y;

        this._target.panel.headerTextField.text = this._systemMessage.title;
        this._bodyTextField = this.createRichText(this._target.panel.bodyTextField);
        this._bodyTextField.text = this._systemMessage.description;

        this._initializeButtons();

        this.stretchBackground();
        this.preventClickThrough();

        this._show();

        this.registerEventListener(SystemMessageEvent.DISMISS_ALL, this._close.bind(this));
    }

    _initializeButtons() {
        const amountOfButtons = this._systemMessage.options.length;
        if (amountOfButtons > SystemMessagePopupMediator.MAX_SUPPORTED_OPTIONS) {
            console.warn(`[SystemMessagePopupMediator] Only supports a maximum of ${SystemMessagePopupMediator.MAX_SUPPORTED_OPTIONS} options!`);
        }

        const availableAmountOfButtons = Math.min(SystemMessagePopupMediator.MAX_SUPPORTED_OPTIONS, amountOfButtons);
        this._currentButtonPanel = this._target.panel[`buttonPanel${availableAmountOfButtons}`];

        // Make the correct button panel visible, so that the correct amount of buttons show
        for (let i = 1; i <= SystemMessagePopupMediator.MAX_SUPPORTED_OPTIONS; i++) {
            this._target.panel[`buttonPanel${i}`].visible = i === amountOfButtons;
        }


        for (let i = 0; i < this._systemMessage.options.length; i++) {
            const option = this._systemMessage.options[i];
            const buttonSkin = this._currentButtonPanel[`button${i + 1}`];
            if (!buttonSkin) {
                console.warn(`[SystemMessagePopupMediator] Current button panel doesn't support or is missing 'button${i + 1}'.`);
                continue;
            }

            buttonSkin.customData = {
                option
            };

            this.createBracketButton(buttonSkin, this._handleOptionButton.bind(this), option.text, SoundType.BRACKET_BUTTON_CLICK);
        }
    }

    _handleOptionButton(evt) {
        const button = evt.target;

        /** @type {SystemMessageOption} */
        const option = button.skin.customData.option;

        if (option.callback) {
            option.callback.call(this);
        }

        if (!option.preventClose) {
            this._close();
        }
    }

    async _show() {
        this._soundManager.playSound(SoundType.COACH_CHAT_PANEL_SHOW);

        this._target.panel.fallbackBg.visible = false;
        this._target.bg.alpha = 0;
        createjs.Tween.get(this._target.bg)
            .to({ alpha: 1 }, 350, createjs.Ease.sineInOut);

        this._target.panel.y = this._target.panel.initialY + 100;
        this._target.panel.alpha = 0;
        await createjs.Tween.get(this._target.panel)
            .to({
                alpha: 1,
                y: this._target.panel.initialY
            }, 450, createjs.Ease.backOut)
            .toPromise();

        this._soundManager.playSound(SoundType.COACH_SHOW);
        this._target.panel.fallbackBg.visible = true;
        this._target.robbyPopup.gotoAndPlay(0);
    }

    _close() {
        this.removeClickListenersFromAllButtons();

        createjs.Tween.removeTweens(this._target.bg);
        createjs.Tween.removeTweens(this._target.panel);

        createjs.Tween.get(this._target.bg)
            .to({ alpha: 0 }, 250, createjs.Ease.sineInOut);
        createjs.Tween.get(this._target.robbyPopup)
            .to({ alpha: 0 }, 250, createjs.Ease.sineInOut);

        createjs.Tween.get(this._target.panel)
            .to({
                alpha: 0,
                y: this._target.panel.initialY - 10
            }, 250, createjs.Ease.sineOut)
            .call(() => {
                this.closePopup(this._target);
            });
    }
}

SystemMessagePopupMediator.MAX_SUPPORTED_OPTIONS = 2;